import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import Editbox from '../../../Part_Sample/Editbox';
import { addCloudDevice } from './js/addcamera';

export default class UniviewAddCamera extends Component {
	constructor(props) {
		super(props);

		let index = -1;
		if (this.props.param.from == 'cameraSelection') index = this.props.param.index;

		this.state = {
			deviceName: '',
			registerCode: '',
			index: index
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('UniviewCameras');
	}

	//Add Camera
	handleRegister = () => {
		//Form validation
		if (this.state.registerCode == '' || this.state.deviceName == '') {
			window.app.showToast(this.props.receiver.getString('ipcam_fillblanks'), 3000);
			return;
		}

		window.app.showLoading();
		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		this.controller_mac_addr = controller_info.mac_addr;
		this.controller_username = controller_info.username;
		let username = uniview_info[this.controller_mac_addr][this.controller_username].username;
		let password = uniview_info[this.controller_mac_addr][this.controller_username].password;
		addCloudDevice(this.addSuccess, this.addFailed, username, password, this.state.registerCode, this.state.deviceName);
	}

	addSuccess = (result) => {
		window.app.hideLoading();
		// Remove the last comma
		if (result.substring(result.length - 1, result.length) == ',') result = result.substring(0, result.length - 1);
		sessionStorage.setItem('devices', result);
		window.app.content_area.current.switch_content.current.handleHideBottomMenu();
		this.props.content_handler('UniviewCameras')
	}

	addFailed = (result) => {
		//console.log(result)
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('ipcam_deviceaddedfailed'), 3000);
	}

	handleChangeDeviceRegisterCode = (val) => {
		this.setState({ registerCode: val })
	}

	handleChangeDeviceName = (val) => {
		const message = val.slice(0, 20);
		this.setState({ deviceName: message })
	}

	handleScanQrCode = () => {
		window.QRScanner.prepare(this.onDone);
	}

	onDone = (err, status) => {
		if (err) {
			// here we can handle errors and clean up any loose ends.
			console.error(err);
		}
		if (status.authorized) {
			// W00t, you have camera access and the scanner is initialized.
			window.QRScanner.show();
			window.app.content_area.current.switch_content.current.showQRScanner();
			window.QRScanner.scan(this.displayContents);
		} else if (status.denied) {
			// The video preview will remain black, and scanning is disabled. We can
			// try to ask the user to change their mind, but we'll have to send them
			// to their device settings with `QRScanner.openSettings()`.
		} else {
			// we didn't get permission, but we didn't get permanently denied. (On
			// Android, a denial isn't permanent unless the user checks the "Don't
			// ask again" box.) We can ask again at the next relevant opportunity.
		}
	}

	displayContents = (err, text) => {
		if (err) {
			console.log(err);
		} else {
			this.setState({
				registerCode: text
			});
		}
		window.app.content_area.current.switch_content.current.hideQRScanner();
	}

	//Delete camera
	handleDeleteCamera = () => {

	}

	render() {
		let main_content_style = {
			position: 'fixed',
			width: '100%',
			color: 'white',
			fontFamily: "system-ui, -apple-system, -apple-system-font, 'Segoe UI', 'Roboto', sans-serif",
			height: this.props.height,
		}

		let container_style = {
			justifyContent: 'center',
			alignItems: 'center',
			height: this.props.height - 86,
			overflow: 'auto',
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('ipcam_addipcamera')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.state.index == -1 ? null : 'delete'}
						handleRightButton={this.handleDeleteCamera}
					/>

					{/* Fields */}
					<div style={container_style}>

						{/* Registeration Code */}
						<div style={{ width: '100%', display: 'flex', alignItems: 'center', paddingTop: 10 }}>
							{/* Registeration Code Input */}
							<div style={{ textAlign: 'left', marginLeft: 20, marginRight: 20 }}>
								<Editbox id='devRegisterCode' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('uniview_devicecode')} inputType='text' onChange={(event) => this.handleChangeDeviceRegisterCode(event.target.value)} value={this.state.registerCode} />
							</div>
						</div>

						{/* Device Name */}
						<div style={{ textAlign: 'center', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
							<Editbox id='deviceName' style={{ width: this.props.width - 40, color: 'black' }} placeholder={this.props.receiver.getString('ipcam_devicename')} inputType='text' maxLength="50" onChange={(event) => this.handleChangeDeviceName(event.target.value)} value={this.state.deviceName} required />
						</div>

						{/* Make Sure Device Online Placeholder */}
						<div style={{ textAlign: 'center', color: '#6E6E6E' }}>
							<p>{this.props.receiver.getString("ipcam_makesuredeviceonline")}</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}